import product from "./product";

export default {
    product,

    noAvailableItems: "Nincsenek megrendelhető termékek."
}